import { Grid } from '@mui/material';
import React from 'react';
import { StyGridContainer } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Result/components/KeysIndicators/KeysIndicators';
import SimulationResultItem from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Result/components/KeysIndicators/SimulationResultItem';
import { getStartYear } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Result/components/KeysIndicators/helpers/dataHelpers';
import { TotalResultAmounts } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Result/components/KeysIndicators/helpers/types';
import { HrSimulation } from 'routes/HumanResourcesModule/Simulation/helpers/types';

type Props = {
    isBudgetProposal: boolean;
    totalAmounts: TotalResultAmounts;
    hrSimulation: HrSimulation;
    isLoading: boolean;
};
const SimulationResult = ({
    isBudgetProposal,
    totalAmounts,
    hrSimulation,
    isLoading,
}: Props) => {
    const startDateYear = getStartYear(hrSimulation.startDate);

    return (
        <StyGridContainer container spacing={2}>
            <Grid
                item
                xs={isBudgetProposal ? 6 : 12}
                sx={{ display: 'flex', height: '100%' }}
            >
                <SimulationResultItem
                    totalAmounts={totalAmounts}
                    startDate={hrSimulation.startDate}
                    year={startDateYear}
                    isLoading={isLoading}
                />
            </Grid>
            {isBudgetProposal && (
                <Grid item xs={6}>
                    <SimulationResultItem
                        totalAmounts={totalAmounts}
                        startDate={hrSimulation.startDate}
                        year={startDateYear + 1}
                        isLoading={isLoading}
                    />
                </Grid>
            )}
        </StyGridContainer>
    );
};

export default SimulationResult;
